import * as React from 'react';
import { RefinementsContext } from '../RefinementsContext';

export const usePagination = () => {
  const { setRefinements } = React.useContext(RefinementsContext);
  const updatePaginationPage = React.useMemo(
    () => () =>
      setRefinements((refinements) => ({
        ...refinements,
        page: Number(refinements.page) + 1,
      })),
    [setRefinements],
  );

  return { updatePaginationPage };
};
